import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    shoppingData: [],
    isFetching: false,
    errorMessage: undefined,
    filteredItems:[],
    rootCategory: "",
    rootCategoryIndex: 0,
    subCategoryIndex: 0,
}

const shopSlice = createSlice({

  name: "shop",
  initialState,
  reducers: {
    setShoppingData(state, action) {
        state.shoppingData = action.payload;
    },
    setRootCategory(state, action) {
      console.log(action.payload);
      state.rootCategory = action.payload;
    },
    setCategorySelection(state, action) {
      state.rootCategoryIndex = action.payload.rootCategoryIndex;
      state.subCategoryIndex = action.payload.subCategoryIndex;
    },
    setDefaultValues(state) {
      state.rootCategory = "";
      state.rootCategoryIndex = 0;
      state.subCategoryIndex = 0;
    }
  },
});



export default shopSlice.reducer;
export const { 
  setShoppingData, 
  setRootCategory, 
  setCategorySelection,
  setDefaultValues
} = shopSlice.actions;
